module.exports = __webpack_public_path__ + "static/media/begin_ttongcjkoh.8bf50ac5.png";